import { type ReactNode, useId } from 'react'

import type { SidebarLink } from './model'
import { SidebarNavList } from './SidebarNavList'
import { SidebarSeparator } from './SidebarSeparator'

interface SidebarNavGroupProps {
  label?: string | null
  links?: SidebarLink[]
  /** Rows of another kind drawn after the links, such as a switch or a sub-menu. */
  children?: ReactNode
  /** A rule above, closing this group off from the one before. */
  separator?: boolean
}

export function SidebarNavGroup({ label, links = [], children, separator }: SidebarNavGroupProps) {
  const labelId = useId()
  if (links.length === 0 && !children) return null

  return (
    <>
      {separator && <SidebarSeparator />}
      <div className="relative flex w-full min-w-0 flex-col px-2 py-3">
        {/* On the rail it fades and its margin takes its height back, so the icons sit evenly. */}
        {label && (
          <div
            id={labelId}
            className="text-ink-600/70 flex h-5 shrink-0 items-center truncate rounded-md px-2 pb-1 text-xs font-medium transition-[margin,opacity] duration-200 ease-linear group-data-[collapsible=icon]:-mt-5 group-data-[collapsible=icon]:opacity-0 motion-reduce:transition-none"
          >
            {label}
          </div>
        )}
        <SidebarNavList links={links} aria-labelledby={label ? labelId : undefined}>
          {children}
        </SidebarNavList>
      </div>
    </>
  )
}
